export const EmailValidator=(email:string)=>{
    const re=/^([a-zA-Z0-9_+][a-zA-Z0-9_+.-]*)+@([\w-]+\.)+[\w]{2,4}$/;
    return re.test(email)?true:false;
}

export const NameValidator = (name: string, regex: RegExp) => {
    return regex.test(name.trim()) ? true : false;
}